import script from "./UserHomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserHomePage.vue?vue&type=script&setup=true&lang=ts"

import "./UserHomePage.vue?vue&type=style&index=0&id=0d7960dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7960dc"]])

export default __exports__